import styled, { css } from 'styled-components';

export const WrapperFixed = styled.div`
  ${({ theme }) => css`
    position: fixed;
    bottom: 66px;
    width: 100%;
    left: ${theme.spacing.km0};
    right: ${theme.spacing.km0};
    background: ${theme.color.background.neutral.default};
    padding: ${theme.spacing.km4} ${theme.spacing.km12};
    border-top: ${theme.border.width.thinner} ${theme.border.style.solid}
      ${theme.color.border.neutral.default};
  `}
`;
